// extracted by mini-css-extract-plugin
module.exports = {"bubble":"SpeechBubble_bubble__19OHm"};